import { Route, Routes } from 'react-router-dom';
import { CaseDetails, CaseList } from './components';

export const Cases = () => {
  return (
    <Routes>
      <Route path="/" element={<CaseList />} />
      <Route path="/:caseId" element={<CaseDetails />} />
    </Routes>
  );
};
